import { render, staticRenderFns } from "./MediaCoreMigrationDialog.vue?vue&type=template&id=b8cf35d6&"
import script from "./MediaCoreMigrationDialog.vue?vue&type=script&lang=js&"
export * from "./MediaCoreMigrationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports